module.exports = __webpack_public_path__ + "static/img/slogn.8e278cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/slogn.png
// module id = yKh1
// module chunks = 1